/*
 *
 * ----------------------------------------------- */

$(window).on("load", function () {
  var $btnDown = $("#btn-down");
  var windowWidth = $(window).width();
  var windowHeight = $(window).height();
  var scrollPos = 0;

  var $sectionService = $(".section-service");
  var $sectionServiceContainer = $(".section-service .horizontal-container");
  var distFromTop1 = $sectionService.offset().top;
  var horLength1 = $sectionServiceContainer.width();
  var scrollDistance1 = distFromTop1 + horLength1 - windowWidth;

  var $stickyWrapper = $(".section-works .sticky-wrapper");
  var distFromTop2 = $stickyWrapper.offset().top;
  var scrollDistance2 = distFromTop2 + windowHeight;

  if ($sectionService && $stickyWrapper) {
    $(document).scroll(function () {
      scrollPos = $(this).scrollTop();
      if (scrollPos >= distFromTop1 && scrollPos <= scrollDistance1) {
        $btnDown.addClass("turn-right");
      } else if (scrollPos >= distFromTop2 && scrollPos <= scrollDistance2) {
        console.log("azsads");
        $btnDown.addClass("turn-right");
      } else {
        $btnDown.removeClass("turn-right");
      }
    });
  }
});
